import React from 'react'
import { Button, Input, Spin, Tooltip } from 'antd'
import { CloseCircleOutlined, SendOutlined } from '@ant-design/icons'

import { serverlessApi } from '../../utils/API'

function InternalKeyCodeCell ({ id, setActiveKeyIds }) {
  const [code, setCode] = React.useState('')
  const [showField, setShowField] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [name, setName] = React.useState('')

  const handleNameSend = () => {
    setLoading(true)

    serverlessApi.setInternalKeyCodeTakenBy(id, { name }).then(() => {
      setName('')

      serverlessApi.getInternalKeyCode(id).then(res => {
        setCode(res.data.code)
        setLoading(false)
        setActiveKeyIds(prev => prev.filter(_id => _id !== id))

        setTimeout(() => {
          setCode('')
          setShowField(false)
        }, 5000)
      }).catch(err => {
        setLoading(false)
        console.error('code error: ', err)
      })
    }).catch(err => {
      setLoading(false)
      console.error('taken by error: ', err)
    })
  }

  const handleCancel = () => {
    setName('')
    setShowField(false)
    setActiveKeyIds(prev => prev.filter(_id => _id !== id))
  }

  if (loading) {
    return <Spin size="small" />
  }

  return (
    <div>
      {showField
        ? code
          ? <div className="text-center">{code}</div>
          : (
            <div className="flex gap-2">
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Keys taken by"
              />

              <Tooltip title="Send" placement="top">
                <div>
                  <Button
                    disabled={!name.trim()}
                    className="bg-buttonTheme flex items-center justify-center"
                    onClick={handleNameSend}
                    icon={<SendOutlined />}
                    type="primary"
                  />
                </div>
              </Tooltip>

              <Tooltip title="Cancel" placement="top">
                <div>
                  <Button
                    className="bg-buttonTheme flex items-center justify-center"
                    onClick={handleCancel}
                    icon={<CloseCircleOutlined/>}
                    type="primary"
                  />
                </div>
              </Tooltip>
            </div>
          )
        : (
          <div className="relative text-center">
            <div className="blur-[4px] transition-[filter] duration-300 ease-in">
              Code
            </div>

            <Button
              variant="outlined"
              className={`absolute top-[-5px] border-0 right-0 w-full z-10 
              !text-[#007d7d] hover:!border-[#007d7d] hover:border-[1px] 
              shadow-none font-medium ${!code ? 'inline-block' : 'hidden'} z-[1]`}
              onClick={() => {
                setShowField(true)
                setActiveKeyIds(prev => ([...prev, id]))
              }}
            >
              View Code
            </Button>
          </div>
        )}
    </div>
  )
}

export default InternalKeyCodeCell
